import { Loader2 } from 'lucide-react';

/**
 * Indicador de loading para acciones de duración 300ms–2s.
 * Variante `inline` acompaña un verbo en línea con texto.
 * Variante `block` se centra en una zona de carga.
 *
 * @param {Object}  props
 * @param {'inline'|'block'} [props.variant='inline']
 * @param {'accent'|'muted'} [props.tone='accent']     Color del spinner.
 * @param {'sm'|'md'}        [props.size]              Default sm en inline,
 *                                                      md en block.
 * @param {string}           [props.label]             Texto debajo del block.
 *                                                      Ignorado en inline.
 */
export default function Spinner({ variant = 'inline', tone = 'accent', size, label }) {
  const resolvedSize = size || (variant === 'block' ? 'md' : 'sm');
  const px = resolvedSize === 'md' ? 24 : 14;
  const colorClass = tone === 'muted' ? 'text-ink-muted' : 'text-accent';

  if (variant === 'block') {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-12">
        <Loader2
          size={px}
          strokeWidth={1.6}
          className={`${colorClass} animate-spin`}
          aria-hidden="true"
        />
        {label && (
          <span className="text-small text-ink-muted font-sans">{label}</span>
        )}
      </div>
    );
  }

  return (
    <Loader2
      size={px}
      strokeWidth={1.6}
      className={`${colorClass} animate-spin inline-block flex-shrink-0`}
      aria-hidden="true"
    />
  );
}
